module.exports = __webpack_public_path__ + "static/media/university-college-cork.b9fcc96e.jpg";